import styled from 'styled-components';
import Grid from 'styled-components-grid';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import breakpoint from 'styled-components-breakpoint';
import { QuotesIcon } from '@images/svg/index';

export const StyledCardWrapper = styled(Grid.Unit)`
  padding: 30px;
  padding-top: 100px;
  ${breakpoint('mobile', 'desktop')`
   padding: 15px;
   padding-top: 50px;
  `}
`;

export const GonextArrow = styled.span`
  font-weight: 500;
  font-size: 24px;
  color: white;
  padding: 2px;
`;

export const StyledCardInner = styled.a`
  cursor: pointer;
  text-decoration: none !important;
  color: black;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  background-color: #efefef;
  transition: 0.3s;
  :hover {
    color: white;
    #quote {
      svg,
      path {
        fill: white;
        stroke: white;
      }
    }

    #gonext {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
`;

export const StyledPostCardList = styled(Grid)`
  min-height: 300px;

  ${breakpoint('desktop')`
  margin-bottom: 2rem;
  min-height: 400px;
 `}
`;

export const StyledLink = styled.a`
  display: block;
  text-decoration: none;
  height: 100%;

  display: none;
  ${breakpoint('desktop')`
    display: block;
  `}
`;

export const StyledCircularFrame = styled.div`
  height: 200px;
  width: 200px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  z-index: 2;
  top: -100px;
  border-radius: 50%;
  left: 50%;
  transform: translateX(-50%);
  border: 10px solid white;

  ${breakpoint('mobile', 'desktop')`
    height: 100px;
    width: 100px;
    top: -50px;
  `}
`;

export const StyledHowOld = styled.span`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 12px;
  z-index: 2;
  font-style: italic;
`;

export const StyledBottomSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledPostImage = styled(LazyLoadImage)`
  display: flex;
  height: 109%;
  min-width: 100%;
  top: 50%;
  left: -41%;
  -webkit-transform: translate(-50%, -50%);
  transform: translateX(-50%, -50%);
  position: relative;
  width: auto;
`;

export const StyledCountry = styled.h3`
  text-align: center;
  margin-top: 130px;
  margin-bottom: 1rem;
  font-weight: 700;
  font-size: 15px;
  color: inherit;
  padding: 0 20px;
  line-height: 28px;
  z-index: 2;

  ${breakpoint('mobile', 'desktop')`
    margin-top: 75px;
    line-height: 22px;
    margin-bottom: 1rem;
    font-size: 13px;
    padding: 0 10px;
  `}
`;

export const GoNext = styled.div`
  width: 0;
  height: 0;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  border-bottom-left-radius: 50%;
  border-top-right-radius: 10px;
  background: #00838d;
  transition: all 0.3s;
`;

export const StyledPatientName = styled.h3`
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 15px;
  color: inherit;
  padding: 0 20px;
  z-index: 2;

  ${breakpoint('mobile', 'desktop')`
    line-height: 22px;
    padding: 0 10px;
    font-size: 15px;
  `}
`;

export const StyledTreatmentName = styled.h3`
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: 15px;
  color: inherit;
  padding: 0 20px;
  z-index: 2;

  ${breakpoint('mobile', 'desktop')`
    line-height: 22px;
  `}
`;

export const StyledCountryFlag = styled.img`
  height: 15px;
  width: auto;
  display: inline;
  margin-right: 10px;
`;

export const Quotes = styled(QuotesIcon)`
  height: 15px;
  width: 15px;
  position: absolute;

  ${({ rev }) =>
    (rev
      ? `
    right: 15px;
    bottom: 32px;
    transform: rotate(180deg);
    `
      : `
    left: 4px;
  top: -8px;
    `)}
`;

export const StyledArticleSummary = styled.div`
  position: relative;
  z-index: 2;
  padding: 0 20px;
  div {
    font-size: 16px;
    color: inherit;
    margin-bottom: 2rem;
    line-height: 24px;
    max-height: 96px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
  }

  ${breakpoint('mobile', 'desktop')`
 padding: 0 10px;
   div{
    font-size: 13px;
   }
   p{
    font-size: 13px;
   }
 `}
`;
